import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from '../actions/MenuAction';
class WALNonCatalogStore extends EventEmitter {
    pageLoad = "";
    saveNonCatalogEntry = "";
    submitResponse = "";
    deleteItem = "";
    submitresponse = "";
    handleWALNonCatalogStore = (action) => {
        switch (action.action.type) {
            case "WalmartNonCatalog_Page_Load": {
                this.pageLoad = action.action.response;
                this.emit('WalmartNonCatalog_Page_Load');
                break;
            }
            case "WalmartNonCatalog_removecartItem": {
                this.deleteItem = action.action.response;
                this.emit('WalmartNonCatalog_removecartItem');
                break;
            }
            case "WalmartNonCatalog_SaveNonCatalogEntry": {
                this.saveNonCatalogEntry = action.action.response;
                this.emit('SaveNonCatalogEntry');
                break;
            }

            case "SubmitOrderResponse": {
                this.submitresponse = action.action.response;
                this.emit('SubmitOrderResponse');
                break;
            }
            case "WalmartNonCatalog_UpdateLineLevelItem": {
                this.deleteItem = action.action.response;
                this.emit('WalmartNonCatalog_UpdateLineLevelItem');
                break;
            }
            case "workordercheckwal": {
                this.workorderresponse = action.action.response;
                this.emit('workordercheckresponsewal');
                break;
            }
            case "workorderfailwal": {
                this.workorderresponse = "failed";
                this.emit('WOfailwal');
                break;

            }
        }
    }
}
const objWALNonCatalogStore = new WALNonCatalogStore;
// Dispatcher code
Dispatcher.register(objWALNonCatalogStore.handleWALNonCatalogStore.bind(objWALNonCatalogStore));
export default objWALNonCatalogStore;